<template>
    <div class="spouse-info-form">
        <ValidationObserver v-slot="{ invalid }" ref="observer">
            <b-form role="form" class="mt-4" @submit.prevent="submit">
                <b-row>
                    <b-col md="8" cols="12">
                        <b-form-group label="Spouse Name">
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ name: true }"
                                :vid="'spouseName'"
                            >
                                <b-form-input
                                v-model="form.name"
                                type="text"
                                placeholder="Enter spouse name"
                                required
                                ></b-form-input>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>

                    <b-col md="8" cols="12">
                        <b-form-group label="Spouse Contact No.">
                            <div class="d-flex justify-content-between">
                                <b-form-input class="col-md-3 mr-1" v-model="form.country_code"></b-form-input>
                                <b-form-input
                                    class="col-md-9"
                                    v-model="form.contact_no"
                                    type="text"
                                    maxlength="17"
                                    @keydown="preventNonNumericInput"
                                    placeholder="Enter Spouse contact number"
                                ></b-form-input>
                            </div>
                        </b-form-group>
                    </b-col>

                    <b-col md="8" cols="12">
                        <b-form-group label="Spouse NRIC">
                            <ValidationProvider
                                v-slot="{ errors }"
                                :rules="{ number_only: true, nric: true }"
                                :vid="'nric'"
                            >
                                <b-form-input
                                v-model="form.nric"
                                type="text"
                                placeholder="Enter spouse nric"
                                maxlength="12"
                                required
                                ></b-form-input>
                                <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>

                    <b-col md="8" cols="12">
                        <b-form-group label="Spouse company Name">
                            <b-form-input
                            v-model="form.company_name"
                            type="text"
                            placeholder="Enter spouse company name"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>

                    <b-col cols="8">
                        <b-button block variant="primary" class="w-50" type="submit" :disabled="invalid">Save</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </ValidationObserver>
    </div>
</template>
<script>
import { Select, Option } from 'element-ui'
import {
    notifyFunctionMixin,
    helperFunctionMixin,
    axios,
    services,
    getHeader
} from '@/assets/js/httpImports.js'
import { mapActions } from 'pinia'
import { useCustomerStore } from '@/stores/customerStore'
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import '@/assets/js/formValidations.js'

    export default {
        name: 'spouse-info-form',
        props: ['customer'],
        mixins:[
            notifyFunctionMixin,
            helperFunctionMixin
        ],
        components: {
            ValidationObserver,
            ValidationProvider,
            [Select.name]: Select,
            [Option.name]: Option,
        },
        data() {
            const {name, contact_no, nric, company_name} = this.customer.spouse || {}
            return {
                form: {
                    customer_id: this.customer.customer_id,
                    name: name ?? null,
                    country_code: this.customer.country_code ?? '+60',
                    contact_no: contact_no ?? null,
                    nric: nric ?? null,
                    company_name: company_name ?? null,
                },
            }
        },
        methods:{
            ...mapActions(useCustomerStore,['getCustomer']),
            submit(){
                this.customer.spouse ? this.update(this.customer.spouse.customer_spouse_id) : this.create()
            },
            update(id){
                axios.put(services.customer + 'customer/'+this.customer.customer_id+'/spouses/' + id, this.form, {headers: getHeader()})
                .then(res  => {
                        this.notifySuccess('<b>Spouse Information: '+this.customer.name+'</b> - Successfully Updated.')
                        this.getCustomer(this.customer.customer_id)
                    })
                    .catch(e => {
                        this.errorFunction(e)
                    })
            },
            create(){
                let formData = this.generateFormData(this.form)
                axios.post(services.customer + 'customer/'+this.customer.customer_id+'/spouses', formData, {headers: getHeader()})
                .then(res  => {
                        this.notifySuccess('<b>Spouse Information: '+this.customer.name+'</b> - Successfully Created.')
                        this.getCustomer(this.customer.customer_id)
                    })
                    .catch(e => {
                        this.errorFunction(e)
                    })
            },
            preventNonNumericInput(event) {
                const keyCode = event.keyCode || event.which;
                const keyValue = String.fromCharCode(keyCode);
                const currencyRegex = /^[\d.,$]+(\.[\d.,$]+)?$/;
                const allowedKeys = [8, 37, 38, 39, 40, 46];
                if (keyCode !== 190 && !currencyRegex.test(keyValue) && !allowedKeys.includes(keyCode)) {
                    event.preventDefault();
                }
            },
        }
    }
</script>